import { render, staticRenderFns } from "./coachPerform.vue?vue&type=template&id=50c60f1c&scoped=true&"
import script from "./coachPerform.vue?vue&type=script&lang=js&"
export * from "./coachPerform.vue?vue&type=script&lang=js&"
import style0 from "./coachPerform.vue?vue&type=style&index=0&id=50c60f1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c60f1c",
  null
  
)

export default component.exports